import classNames from 'classnames';

import s from './CartSellerProductsGroup.sss';

type CartSellerProductsGroupPreloaderProps = {
  productsCount?: number
  className?: string
};

export const CartSellerProductsGroupPreloader: React.FC<CartSellerProductsGroupPreloaderProps> = ({
  productsCount = 1,
  className,
}) => (
  <div className={classNames(s.root, s.preloader, className)}>
    <div>
      {
        Array(productsCount)
          .fill(null)
          .map(
            (_, i) => <div key={i} className={s.productPreloader} />,
          )
      }
    </div>

    <div className={s.buttonPreloader} />
  </div>
);
